var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButtonArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.399 9.971"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.414 1.414l3.571 3.571-3.571 3.571",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjM5OSIgaGVpZ2h0PSI5Ljk3MSIgdmlld0JveD0iMCAwIDYuMzk5IDkuOTcxIj4NCiAgPHBhdGggZD0iTTQyOTAuMTQzLDY0OWwzLjU3MSwzLjU3MS0zLjU3MSwzLjU3MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyODguNzI5IC02NDcuNTg2KSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPg0KPC9zdmc+DQo=";
export { SvgButtonArrowRight as ReactComponent };